var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#827127"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M4 21V4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M4 13.406c6.154 0 7.385 3.778 16 3.778V7.778C11.385 7.778 10.154 4 4 4v9.406"
  }))));
};
export default SvgFlag;